import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Integrations = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 32 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <rect x="13.5" y="2.5" width="17" height="17" rx="8.5" fill="white" />
        <path
          d="M22 16C24.7614 16 27 13.7614 27 11C27 8.23858 24.7614 6 22 6C19.2386 6 17 8.23858 17 11C17 13.7614 19.2386 16 22 16Z"
          fill="#597CFF"
        />
        <path
          d="M22 16C24.7614 16 27 13.7614 27 11C27 8.23858 24.7614 6 22 6C19.2386 6 17 8.23858 17 11C17 13.7614 19.2386 16 22 16Z"
          fill="url(#paint0_radial_1271_385009)"
        />
        <path
          d="M22 16C24.7614 16 27 13.7614 27 11C27 8.23858 24.7614 6 22 6C19.2386 6 17 8.23858 17 11C17 13.7614 19.2386 16 22 16Z"
          fill="url(#paint1_radial_1271_385009)"
        />
        <path
          d="M22 16C24.7614 16 27 13.7614 27 11C27 8.23858 24.7614 6 22 6C19.2386 6 17 8.23858 17 11C17 13.7614 19.2386 16 22 16Z"
          fill="url(#paint2_radial_1271_385009)"
        />
        <path
          d="M22 16C24.7614 16 27 13.7614 27 11C27 8.23858 24.7614 6 22 6C19.2386 6 17 8.23858 17 11C17 13.7614 19.2386 16 22 16Z"
          fill="url(#paint3_radial_1271_385009)"
        />
        <path
          d="M24.0291 11.9768C23.989 11.9768 23.9537 12.01 23.917 12.0824C23.5022 12.9063 22.7857 13.4892 21.9566 13.4892C20.998 13.4892 20.4043 12.6416 20.4043 11.4707C20.4043 9.4872 21.5327 8.3404 22.5237 8.3404C22.9868 8.3404 23.2696 8.62544 23.2696 9.07905C23.2696 9.61741 22.9574 9.90246 22.9574 10.0923C22.9574 10.1776 23.0115 10.2292 23.1188 10.2292C23.5501 10.2292 24.0562 9.74384 24.0562 9.05822C24.0562 8.39343 23.4654 7.90479 22.4744 7.90479C20.8365 7.90479 19.3809 9.39203 19.3809 11.4498C19.3809 13.0427 20.3095 14.0953 21.7425 14.0953C23.2634 14.0953 24.1428 12.6132 24.1428 12.1322C24.1428 12.0256 24.0872 11.9768 24.0291 11.9768Z"
          fill="white"
        />
        <rect x="13.5" y="2.5" width="17" height="17" rx="8.5" stroke="#2B2F38" />
        <rect x="7.5" y="13.5" width="17" height="17" rx="8.5" fill="white" />
        <g clipPath="url(#clip0_1271_385009)">
          <path
            d="M15.4686 17.9195L11.7374 19.4635C11.5299 19.5493 11.5321 19.8441 11.7408 19.9269L15.4876 21.4127C15.8168 21.5432 16.1835 21.5432 16.5127 21.4127L20.2595 19.9268C20.4682 19.8441 20.4705 19.5494 20.2629 19.4635L16.5318 17.9195C16.1914 17.7786 15.809 17.7786 15.4686 17.9195"
            fill="#FCB400"
          />
          <path
            d="M16.3325 22.224V25.9358C16.3325 26.1123 16.5105 26.2333 16.6746 26.1682L20.8497 24.5477C20.8963 24.5292 20.9362 24.4972 20.9644 24.4557C20.9925 24.4143 21.0075 24.3654 21.0075 24.3153V20.6035C21.0075 20.4269 20.8295 20.3061 20.6654 20.3711L16.4903 21.9917C16.4438 22.0101 16.4039 22.0422 16.3757 22.0836C16.3476 22.125 16.3325 22.174 16.3325 22.2241"
            fill="#18BFFF"
          />
          <path
            d="M15.3579 22.4156L14.1188 23.0139L13.993 23.0747L11.3774 24.3279C11.2117 24.4079 11 24.2871 11 24.1029V20.6191C11 20.5525 11.0342 20.4949 11.08 20.4517C11.0988 20.4329 11.1201 20.4169 11.1433 20.4041C11.2058 20.3666 11.2949 20.3566 11.3707 20.3866L15.3371 21.9582C15.5387 22.0382 15.5545 22.3207 15.3579 22.4156"
            fill="#F82B60"
          />
          <path
            d="M15.358 22.4156L14.1189 23.0139L11.0801 20.4516C11.0989 20.4329 11.1202 20.4169 11.1434 20.4041C11.2059 20.3666 11.295 20.3566 11.3708 20.3866L15.3372 21.9582C15.5388 22.0382 15.5546 22.3207 15.358 22.4156"
            fill="black"
            fillOpacity="0.25"
          />
        </g>
        <rect x="7.5" y="13.5" width="17" height="17" rx="8.5" stroke="#2B2F38" />
        <rect x="1.5" y="2.5" width="17" height="17" rx="8.5" fill="white" />
        <path
          d="M12.2833 8.40867C12.2833 9.66937 11.2611 10.6923 10.0004 10.6923C8.73893 10.6923 7.71673 9.67017 7.71673 8.40867C7.71673 7.14719 8.73893 6.125 10.0004 6.125C11.2611 6.125 12.2833 7.14719 12.2833 8.40867ZM7.03367 11.2629C5.77301 11.2629 4.75 12.2851 4.75 13.5458C4.75 14.8064 5.77219 15.8294 7.03367 15.8294C8.29519 15.8294 9.31738 14.8073 9.31738 13.5458C9.31738 12.2851 8.29519 11.2629 7.03367 11.2629ZM12.9663 11.2629C11.7048 11.2629 10.6827 12.2851 10.6827 13.5466C10.6827 14.808 11.7048 15.8302 12.9663 15.8302C14.227 15.8302 15.25 14.808 15.25 13.5466C15.25 12.2851 14.2278 11.2629 12.9663 11.2629Z"
          fill="#F06A6A"
        />
        <rect x="1.5" y="2.5" width="17" height="17" rx="8.5" stroke="#2B2F38" />
        <defs>
          <radialGradient
            id="paint0_radial_1271_385009"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(18.9316 14.8632) rotate(-49.4156) scale(7.73416)"
          >
            <stop stopColor="#597CFF" />
            <stop offset="1" stopColor="#472F92" />
          </radialGradient>
          <radialGradient
            id="paint1_radial_1271_385009"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(19.6474 7.13684) rotate(54.7035) scale(8.72168)"
          >
            <stop stopColor="#6420FF" />
            <stop offset="1" stopColor="#6420FF" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="paint2_radial_1271_385009"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(18.9316 14.8632) rotate(-45.1954) scale(7.64053 3.51398)"
          >
            <stop stopColor="#597CFF" />
            <stop offset="1" stopColor="#597CFF" />
          </radialGradient>
          <radialGradient
            id="paint3_radial_1271_385009"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(21.0895 7.34737) rotate(66.5198) scale(7.87295 13.1889)"
          >
            <stop stopColor="#7D2AE7" />
            <stop offset="1" stopColor="#7D2AE7" stopOpacity="0" />
          </radialGradient>
          <clipPath id="clip0_1271_385009">
            <rect width="10" height="8.37209" fill="white" transform="translate(11 17.814)" />
          </clipPath>
        </defs>
      </svg>
    )
  },
)

export default Integrations
